// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3dO20","open":"open___2NQf5","trigger":"trigger___2hjUL","triggerOpen":"triggerOpen___3a6YO","container":"container___88HNI","dropdown":"dropdown___2DAj4"};